import axios from "axios";
import getErrorDetails from "./helpers/getErrorDetails";
import paramsSerializer from "./helpers/paramsSerializer";
import {
  addPaginationAndSort,
  getPaginationInfoFromHeaders,
  PaginatedList,
} from "./helpers/pagination";
import Bank from "../models/Bank";
import { isEmpty } from "lodash";

export async function getBanks(
  qsParams: {
    search: string;
    page: number;
    order: any;
    orderBy: any;
    limit: number;
  },
  options?: any
): Promise<PaginatedList<Bank>> {
  const { search } = qsParams;
  const params = { ...addPaginationAndSort<Bank>(qsParams) };

  if (!isEmpty(search)) {
    Object.assign(params, { search: search });
  }

  try {
    const response = await axios({
      ...options,
      method: "GET",
      url: "/banks",
      params,
      paramsSerializer,
    });

    const { data = {}, headers: responseHeaders = {} } = response;

    const {
      totalItems,
      currentPage,
      currentLimit,
    } = getPaginationInfoFromHeaders(responseHeaders);

    return {
      list: data || [],
      totalItems: totalItems,
      currentPage,
      currentLimit,
    };
  } catch (error) {
    throw getErrorDetails(error);
  }
}

export async function getBank(id: string, options?: any): Promise<Bank> {
  try {
    const response = await axios({
      ...options,
      method: "GET",
      url: `/banks/${id}`,
    });
    const { data = {} } = response;
    return data;
  } catch (error) {
    throw getErrorDetails(error);
  }
}

export async function patchBank(
  id: string,
  bank: Bank,
  options?: any
): Promise<Bank> {
  try {
    const response = await axios({
      ...options,
      method: "PUT",
      url: `/banks/${id}`,
      data: {
        ...bank,
        ...(bank.country ? { country: bank.country?.id } : {}),
      },
    });
    const { data = {} } = response;
    return await getBank(data.id, options);
  } catch (error) {
    throw getErrorDetails(error);
  }
}
